<template>
  <div class="logon_wrap">
    <TopNav></TopNav>
    <div class="c_outer">
      <component class="c_inner" :is="curComponent" @next-step="nextStep"></component>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TheTopNav'
import RegistUser from './childrens/RegistUser'
import RegistSuccess from './childrens/RegistSuccess'
import ForgetPassword from './childrens/ForgetPassword'

export default {
  name: 'Registry',
  components: { TopNav, RegistUser, RegistSuccess, ForgetPassword },
  data () {
    return {
      curComponent: 'regist-user'
    }
  },
  created () {
    if (this.$route.query.type === 'password') this.curComponent = 'forget-password'
  },
  methods: {
    nextStep () {
      this.curComponent = 'regist-success'
    }
  }
}
</script>

<style lang="scss" scoped>
.logon_wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../../assets/login_bg.png') no-repeat;
  background-size: cover;
  background-position: center center;
  overflow-y: auto;
}
.c_outer {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 960px;
  height: 680px;
  margin-top: 50px;
  background-color: #fff;
  border-radius: 20px;
  transform: translate(-50%, -50%);
}
.c_inner {
  width: 360px;
  margin: 0 auto;
}
</style>
